import TablaPaginada from "components/comun/TablaPaginada";
import React from "react";
import {
  Card,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { apiFichajesService } from "services/apiFichajesService";
import { showAppAlert } from "components/common/AppAlerts";
import { useAuth } from "context/AuthProvider";

const ListaFichajes = (props) => {
  const { empresa } = useAuth();

  const handleDelete = async (id) => {
    const empresaId = empresa?.id || props.empleado?.empresaId;
    if (!empresaId) {
      showAppAlert("No se pudo identificar la empresa del fichaje.", "error");
      return;
    }

    const motivoEliminacion = window.prompt("Motivo de eliminacion del fichaje manual:");
    if (motivoEliminacion === null) {
      return;
    }
    if (!motivoEliminacion.trim()) {
      showAppAlert("Debe indicar un motivo de eliminacion.", "warning");
      return;
    }

    try {
      await apiFichajesService.borrarFichaje(id, empresaId, motivoEliminacion.trim());
      showAppAlert("Fichaje eliminado con trazabilidad.", "success");
      if (typeof props.handleUpdate === "function") {
        props.handleUpdate();
      }
    } catch (error) {
      showAppAlert(error?.message || "No se pudo eliminar el fichaje.", "error");
    }
  };

  const cabecera = (
    <tr>
      <th>Dia</th>
      <th className="text-center">Hora</th>
      <th className="text-center">Tipo</th>
      <th className="text-center">Coordenadas</th>
      {props.showTraceability ? <th className="text-center">Motivo ajuste</th> : ""}
      {props.showTraceability ? <th className="text-center">Creado por</th> : ""}
      {props.showTraceability ? <th className="text-center">Creado el</th> : ""}
      {props.showTraceability ? <th className="text-center">Motivo eliminacion</th> : ""}
      {props.showTraceability ? <th className="text-center">Eliminado por</th> : ""}
      {props.showTraceability ? <th className="text-center">Eliminado el</th> : ""}
      {props.administrar && !props.showTraceability ? <th className="text-right">Acciones</th> : ""}
    </tr>
  );

  const renderDateTime = (value) => {
    if (!value) {
      return "-";
    }
    const date = value.split("T")[0] || "-";
    const time = value.split("T")[1]?.split(".")[0]?.substring(0, 5) || "";
    return time ? `${date} ${time}` : date;
  };

  const acciones = (id) => {
    return (
      <>
        <UncontrolledDropdown>
          <DropdownToggle
            className="btn-icon-only "
            href=""
            role="button"
            size="sm"
            color="secondary"
            onClick={(e) => e.preventDefault()}
          >
            <i className="fas fa-ellipsis-v" />
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-arrow" right>
            <DropdownItem onClick={() => handleDelete(id)}>Eliminar</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </>
    );
  };

  const datos = (
    <>
      {(props.fichajes || []).map((fichaje, index) => {
        const fecha = fichaje?.horaFichaje?.split("T")[0] || "-";
        const hora = fichaje?.horaFichaje?.split("T")[1]?.split(".")[0]?.substring(0, 5) || "-";
        const hasCoordinates =
          fichaje?.latitud !== null &&
          fichaje?.latitud !== undefined &&
          fichaje?.longitud !== null &&
          fichaje?.longitud !== undefined;

        return (
          <tr
            key={index}
            className={fichaje.tipo === "entrada" ? "table-success" : "table-danger"}
          >
            <td>{fecha}</td>
            <td className="text-center">{hora}</td>
            <td className="text-center">{fichaje.tipo || "-"}</td>
            <td className="text-center">
              {hasCoordinates ? (
                <a
                  href={`https://maps.google.com/maps?q=${fichaje.latitud},${fichaje.longitud}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Coordenadas
                </a>
              ) : (
                "-"
              )}
            </td>
            {props.showTraceability ? <td className="text-center">{fichaje.motivoAjuste || "-"}</td> : ""}
            {props.showTraceability ? <td className="text-center">{fichaje.createdBy || "-"}</td> : ""}
            {props.showTraceability ? <td className="text-center">{renderDateTime(fichaje.createdAt)}</td> : ""}
            {props.showTraceability ? <td className="text-center">{fichaje.motivoEliminacion || "-"}</td> : ""}
            {props.showTraceability ? <td className="text-center">{fichaje.deletedBy || "-"}</td> : ""}
            {props.showTraceability ? <td className="text-center">{renderDateTime(fichaje.deletedAt)}</td> : ""}
            {props.administrar && !props.showTraceability ? (
              <td className="text-right">{acciones(fichaje.id) }</td>
            ) : (
              ""
            )}
          </tr>
        );
      })}
    </>
  );

  return (
    <>
      <Card>
        <CardHeader>{props.title || `Fichajes: ${props.empleado?.nombre || ""}`}</CardHeader>
        <TablaPaginada
          titulo="Fichajes empleado:"
          cabecera={cabecera}
          datos={datos}
          currentPage={props.currentPage}
          totalPage={props.totalPage}
          setCurrentPage={props.setCurrentPage}
        ></TablaPaginada>
      </Card>
    </>
  );
};

export default ListaFichajes;
